<div class="video-chat-call-toast" cdkDrag *ngIf="showToast">
  <div class="wrapper">
    <div class="avatar-container item {{ getThemeClass(chat.ChatID) }}">
      <app-avatar [workItemId]="chat.ChatID" [workItemType]="workItemTypes.CHAT"></app-avatar>
    </div>
    <div class="text-container">
      <div class="visitor-name">{{ chat.ChatName }}</div>
      <div class="video-chat-action" *ngIf="!isInitiatedByVisitor">
        {{ 'videoChatCallToast.videoChatActions.ongoingCall' | translate }}
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="wrapper">
    <div class="btn-show-call" (click)="showVideoCall()" *ngIf="!isInitiatedByVisitor">
      <svg-icon icon="call"></svg-icon>
      {{ 'videoChatCallToast.buttons.showCall' | translate }}
    </div>
  </div>
</div>
